import { render, staticRenderFns } from "./error-feedback.vue?vue&type=template&id=0b195a8c&scoped=true&"
import script from "./error-feedback.vue?vue&type=script&lang=js&"
export * from "./error-feedback.vue?vue&type=script&lang=js&"
import style0 from "./error-feedback.vue?vue&type=style&index=0&id=0b195a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b195a8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b195a8c')) {
      api.createRecord('0b195a8c', component.options)
    } else {
      api.reload('0b195a8c', component.options)
    }
    module.hot.accept("./error-feedback.vue?vue&type=template&id=0b195a8c&scoped=true&", function () {
      api.rerender('0b195a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/error-feedback.vue"
export default component.exports